import * as React from 'react';
import Button from '@mui/material/Button';
import styles from "../../../assets/styles/componentStyles/button.module.scss"
import thunderbolt from "../../../assets/thunderBolt.png";
import flagMoveForwardImg from "../../../assets/moveForwardArrow.png";
import { GlobalStyles } from '@mui/material';
import globalStyles from "../../../assets/styles/global.module.scss";
import upgradeIcon from "../../../assets/upgradeIcon.svg";
import downloadChromeExtensionIcon from "../../../assets/downloadExtensionIcon.svg";
import createPersonaIcon from "../../../assets/createPersona.png";
import updatePersonaIcon from "../../../assets/updatePersona.svg";
import addPersona from "../../../assets/addPersona.svg";
import updatePersona from "../../../assets/update.svg";
import deletePersona from "../../../assets/deletePersona.svg";
import upgrade from "../../../assets/upgrade.svg";
import IconsColor from '../iconsColor';

interface buttonProps {
  buttonText: string | React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: () => void;
  onMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className: string;
  disabled?: boolean;
  flagGenerate?: boolean;
  flagMoveForward?: boolean
  flagFullWidth?: boolean;
  height?: string;
  flagUpgrade?: boolean;
  flagDownloadExtension?: boolean;
  flagCreatePersona?: boolean;
  flagUpdatePersona?: boolean;
  flagDeletePersona?: boolean;
  flagAddPersona?: boolean;
  flagMobile?: boolean;
  id?: string;
  sx?: any;
  variant?: "text" | "contained" | "outlined"
  startIcon?: any;
  endIcon?: any;
}
export default function GlobalButton(props: buttonProps) {


  return (
    <Button
      id={props.id ? props.id : ""}
      disabled={props.disabled}
      aria-label={typeof props.buttonText === "string" ? props.buttonText : ""}
      sx={{ opacity: props.disabled ? "0.5" : "1", textTransform: "unset", height: props.height, minWidth: "unset", ...props.sx }}
      onMouseLeave={props.onMouseLeave}
      onMouseDown={props.onMouseDown}
      onClick={props.onClick} className={props.flagFullWidth ? `${globalStyles.fullwidth} ${styles[props.className]} ${globalStyles.primaryButtonFontStyle}` : `${styles[props.className]} ${globalStyles.primaryButtonFontStyle}`}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      variant={props.variant ? props.variant : "contained"}>
      {props.flagGenerate && <img alt="upgrade" src={upgrade} style={{ width: "18px", height: "auto", marginRight: "5px" }} />}
      {props.flagUpgrade && <IconsColor iconName="diamond" width="17px" height="16px" fillColor="#fff" style={{ marginRight: props.flagMobile ? "" : "7px" }} />}
      {props.flagDownloadExtension && <img alt="extension" src={downloadChromeExtensionIcon} style={{ marginRight: props.flagMobile ? "" : "9px" }} />}
      {props.buttonText}
      {props.flagMoveForward && <img alt="arrow" src={flagMoveForwardImg} style={{ width: "24px", height: "auto", display: "flex", paddingLeft: "5px" }} />}
    </Button>
  );
}
